<template>
  <ion-page>
    <ion-header class="ion-no-border">
      <ion-toolbar>
        <ion-buttons slot="start">
          <back-button
            :defaultHref="{ name: 'home' }"
            :icon="require('@lib/assets/icons/icon_zurueck.svg')"
            text="">
          </back-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content ref="content" :fullscreen="true">
      <ion-grid fixed class="ion-padding">
        <ion-row>
          <ion-col>
            <img
              class="u-rounded"
              src="@/assets/img/content/video_anleitung_big.jpg" />
            <p>
              <b>So einfach geht’s:</b>
            </p>
            <p>
              1. Fordern Sie Ihre Teilnahmeerklärung an Rufen Sie gebührenfrei
              <a href="tel:+498941248300">089 4124-8300</a> an oder geben Sie
              hier Ihren Wunsch für die Teilnahme am Coaching an.
            </p>
            <p>
              2. Die Teilnahmeerklärung wird Ihnen von der ARAG in Kürze per
              Post zugestellt.
            </p>
            <p>
              3. Senden Sie bitte die unterzeichnete Teilnahmeerklärung an
              MedicalContact
            </p>
            <p>
              4. Ihr persönlicher Coach von MedicalContact ruft Sie an. Er führt
              mit Ihnen ein Aufnahmegespräch in das Programm und erstellt mit
              Ihnen gemeinsam die Inhalte Ihres Coachings.
            </p>
            <p>
              5. Das Coaching kann beginnen Ihr Coach führt regelmäßig mit Ihnen
              Gespräche.
              <!-- Auch medizinische Hilfsmittel wie Schrittzähler,
              Blutzucker- oder Blutdruckmessgerät werden Ihnen bei Bedarf
              kostenlos zur Verfügung gestellt. -->
            </p>
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script>
import { chevronBack } from "ionicons/icons";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonContent,
  IonButton,
  IonGrid,
  IonRow,
  IonCol,
  IonIcon,
  IonButtons,
  IonBackButton,
} from "@ionic/vue";

export default {
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    IonContent,
    IonButton,
    IonGrid,
    IonRow,
    IonCol,
    IonIcon,
    IonButtons,
    IonBackButton,
  },
  data() {
    return {};
  },
  setup() {
    return {
      chevronBack,
    };
  },
};
</script>

<style lang="scss" scoped></style>
